import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const PopularRoutes = ({ routes, currentRoute }) => {
  const filteredRoutes = routes?.filter(
    route => `${route?.from}-${route?.to}` !== `${currentRoute?.from}-${currentRoute?.to}`
  );

  return (
    <div className="space-y-4 md:space-y-6">
      <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground">
        Other Popular Routes
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {filteredRoutes?.slice(0, 6)?.map((route, index) => (
          <Link
            key={index}
            to="/route-details"
            className="group bg-card rounded-xl border border-border p-4 md:p-6 hover:shadow-lg hover:border-primary transition-all duration-200"
          >
            <div className="space-y-4">
              <div className="flex items-start justify-between">
                <div className="flex-1 min-w-0">
                  <h3 className="text-base md:text-lg font-semibold text-foreground group-hover:text-primary transition-colors duration-200 truncate">
                    {route?.from} → {route?.to}
                  </h3>
                  <p className="text-sm text-muted-foreground mt-1">{route?.distance}</p>
                </div>
                <Icon
                  name="ArrowRight"
                  size={20}
                  className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all duration-200 flex-shrink-0"
                />
              </div>
              
              <div className="flex items-center justify-between pt-3 border-t border-border">
                <div className="flex items-center gap-2">
                  <Icon name="Clock" size={16} className="text-primary" />
                  <span className="text-sm text-foreground">{route?.duration}</span>
                </div>
                <div className="text-right">
                  <p className="text-xs text-muted-foreground">Starting from</p>
                  <p className="text-base md:text-lg font-bold text-foreground whitespace-nowrap">
                    ₹{route?.startingPrice?.toLocaleString('en-IN')}
                  </p>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default PopularRoutes;